import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/liveBroadcast',
  component: LAYOUT,
  name: 'LiveBroadcast',
  redirect: '/liveBroadcast/detail',
  meta: {
    title: '直播录播分享',
  },
  children: [
    {
      path: 'detail',
      name: 'LiveBroadcastDetail',
      meta: {
        // title: '直播录播详情',
        title: '北京汽车',
      },
      component: () => import('@/views/liveBroadcast'),
    },
  ],
};
